export default "/images/server.svg?24ecaa04d65d608174abb3806ac50a9d";